import { NotificationInfoItem } from '../../interfaces/api/notificationInfo';

const COUNSELING_ANNOUNCEMENT_INFO_TYPE: string = 'counselingAnnouncement';

/**
 * カウンセリング予約訴求をお知らせリストの先頭にする処理
 * @param {NotificationInfoItem[]} notificationInfoList - お知らせ情報のリスト
 * @returns {Promise<NotificationInfoItem[]>} - お知らせ情報のリスト
 */
export const moveCounselingAnnouncementsToTop = (
  notificationInfoList: NotificationInfoItem[]
) => {
  const counselingAnnouncementInfo: NotificationInfoItem[] = [];
  const counselingExcludedList: NotificationInfoItem[] = [];
  notificationInfoList.forEach((item) => {
    if (item.infoType === COUNSELING_ANNOUNCEMENT_INFO_TYPE) {
      counselingAnnouncementInfo.push(item);
    } else {
      counselingExcludedList.push(item);
    }
  });

  return [...counselingAnnouncementInfo, ...counselingExcludedList];
};
